import React from "react";
import FileUploadPreview from "./FileUploadPreview";
import { Box, Stack, TextField, Typography } from "@mui/material";
import { CONSTANTS } from "./constant";

const AuthorFields = ({
  getFieldValue,
  handleChange,
  handleFileChange,
  error,
  errors = {},
}) => {
  return (
    <>
      {/* Author Names */}
      <Box mb={2} mt={2}>
        <Typography variant="h6" gutterBottom>
          {CONSTANTS.AUTHOR_DETAILS_SECTION}
        </Typography>
        <Stack direction="row" spacing={2}>
          <TextField
            fullWidth
            label={CONSTANTS.AUTHOR_NAME_LABEL}
            name="author.name.en"
            value={getFieldValue("author.name.en")}
            onChange={handleChange}
            sx={{ flex: 1, minWidth: "300px" }}
            error={!!errors["author.name.en"]}
            helperText={errors["author.name.en"]}
          />
          <TextField
            fullWidth
            label={CONSTANTS.AUTHOR_NAME_LABEL_HINDI}
            name="author.name.hi"
            value={getFieldValue("author.name.hi")}
            onChange={handleChange}
            sx={{ flex: 1, minWidth: "300px" }}
            error={!!errors["author.name.hi"]}
            helperText={errors["author.name.hi"]}
          />
        </Stack>
      </Box>
      {/* Author Image Upload and Preview */}
      <Box mb={2} mt={1}>
        <Box sx={{ flex: 1, minWidth: "300px" }}>
          <FileUploadPreview
            label={CONSTANTS.UPLOAD_AUTHOR_IMAGE_BUTTON}
            id="author-image-upload"
            fileField="authorImage"
            allowUrl
            acceptedTypes={CONSTANTS.ACCEPTED_IMAGE_TYPES}
            urlField="author.image"
            getFieldValue={getFieldValue}
            previewUrl={getFieldValue("author.image")}
            onFileChange={handleFileChange}
            onRemove={() =>
              handleFileChange({ target: { name: "authorImage", value: null } })
            }
            onUrlChange={handleChange}
            error={
              error?.authorImage ||
              error?.["author.image"] ||
              errors["author.image"]
            }
          />
        </Box>
      </Box>
    </>
  );
};

export default AuthorFields;
